<template>
    <div class="sequenceFrom">
      <div class="customer-info">
        <div class="customer-info-item">
          <div class="customer-info-title">
            <!--图标-->
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-qiyexinxi"></use>
            </svg>
            <span>基础设置</span>
          </div>
          <div class="customer-info-button">
            <!--展开-->
            <svg v-if="show" class="icon" aria-hidden="true" @click="changeShow">
              <use xlink:href="#icon-zhankaizhuangtai"></use>
            </svg>
            <!--收起-->
            <svg v-else class="icon" aria-hidden="true" @click="changeShow">
              <use xlink:href="#icon-shouqizhuangtai"></use>
            </svg>
          </div>
        </div>
        <div  class="editForm" v-show="show">
          <el-row :span="20" :offset="2">
            <el-form :ref="'form'+idx"  :model="wagesFrom" label-width="168px" :rules="rules">
              <el-col :span="12">
                <el-form-item label="工资单名称" prop="name">
                  <el-input v-model="wagesFrom.name" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否显示空值" prop="empty">
                  <el-select v-model="wagesFrom.empty" placeholder="是否显示空值">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否显示双语" prop="lang">
                  <el-select v-model="wagesFrom.lang" placeholder="是否显示双语">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="适用机构" prop="org" >
                  <treeselect v-model="wagesFrom.org" @select ="selectEvt" :multiple="true" :options="options" />
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
      </div>
    </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  export default {
    name: "paySequence",
    components:{Treeselect},
    props:{
      idx:{
        type:Number,
        default:0
      },
      wagesFrom:{
        type:Object,
        default:function(){
          return {
            name:"",
            empty:1,
            org:[],
            lang:1,
          }
        }
      }
    },
    watch: {
      multiple(newValue) {
        if (newValue) {
          this.value = this.value ? [ this.value ] : []
        } else {
          this.value = this.value[0]
        }
      },
    },
    data(){
      return{
        show:true,
        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
          ],
          empty: [
            { required: true, message: '空值是否显示', trigger: 'change' }
          ],
          org: [
            { required: true, message: '请选择适用机构', trigger: 'change' }
          ],
          lang: [
            { required: true, message: '请选择是否显示双语', trigger: 'change' }
          ],
        },
        options: [{
          id: 'org2',
          label: 'org2',
          children: [{
            id: 'aa',
            label: 'aa',
          }, {
            id: 'ab',
            label: 'ab',
          }],
        }, {
          id: 'b',
          label: 'b',
        }, {
          id: 'c',
          label: 'c',
        }],
      }
    },
    methods:{
      changeShow(){
        debugger
        this.show ?this.show = false:this.show = true
      },
      submitForm() {
        debugger
        this.$refs['form'+this.idx].validate((valid) => {
          if (valid) {
            // 修改标题
            debugger
            this.$emit("changeName",this.wagesFrom.name)
            return true;
          } else {
            this.$message.error("请正确填写表单！")
            return false;
          }
        });
      },
      selectEvt(e){
        console.log(e.id);
      }
    }
  };
</script>

<style scoped>
  .editForm{
    width: calc(100% - 100px);
  }
  .sequences,.sequenceBox{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sequenceBox{
    width: 160px;
  }
  .sequence{
    width: 120px;
    height: 40px;
    color:#ffffff;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    background: #7ea7ca;
    border-radius: 4px;
    margin-right: 10px;
    /*cursor: pointer;*/
  }
  .sequenceArrow{
    color:#bbbbbb;
    font-size: 20px;
  }
  .sequenceBox.active .sequence{
    background: #008AFF;
    font-size: 16px;
  }
  .sequenceBox.pass .sequence{
    background: #008AFF;
  }
  .sequences .el-form >>> .el-form-item  .el-radio-group{
    margin-top: 0px;
    line-height: 30px;
  }
</style>
